// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file bffuser/v1/supply_48_data_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import { Supply48DataService } from "./supply_48_data_service_pb";

/**
 * ListSupply48Data は指定期間・カテゴリ・エリアの 48 点データを供給源 (Supply48DataSource) 単位で返す。
 * 比較モード「前日計画」はフロントが date_from を 1 日前に広げて同 RPC を呼ぶだけ (専用 RPC 不要)。
 *
 * @generated from rpc bffuser.v1.Supply48DataService.ListSupply48Data
 */
export const listSupply48Data = Supply48DataService.method.listSupply48Data;

/**
 * SaveSupply48Data は複数行を 1 トランザクションで一括保存する。
 *
 * @generated from rpc bffuser.v1.Supply48DataService.SaveSupply48Data
 */
export const saveSupply48Data = Supply48DataService.method.saveSupply48Data;

/**
 * ImportSupply48Data は CSV 取込 (取引ID, 日付, コマ1〜48) を検証・反映する
 * (dry_run=true でプレビュー、false で確定)。acting_member_id は
 * BFF handler が eauth セッションから解決する。
 *
 * @generated from rpc bffuser.v1.Supply48DataService.ImportSupply48Data
 */
export const importSupply48Data = Supply48DataService.method.importSupply48Data;
